import Hero from "./Hero";
import More from "./More";

const Preview = () => {
  return (
    <>
      <Hero />
      <More />
    </>
  );
};

export default Preview;
